import { render, staticRenderFns } from "./ConcursoPublico.vue?vue&type=template&id=b6f3adb6&"
import script from "./ConcursoPublico.vue?vue&type=script&lang=js&"
export * from "./ConcursoPublico.vue?vue&type=script&lang=js&"
import style0 from "./ConcursoPublico.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports